import { render, staticRenderFns } from "./MenuMobileButton.vue?vue&type=template&id=1653fa3c"
import script from "./MenuMobileButton.vue?vue&type=script&lang=js"
export * from "./MenuMobileButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports